if (!window.shopifyAccountLocaleScriptLoaded) {
  window.shopifyAccountLocaleScriptLoaded = true;
  (function() {
    const locale = window?.Shopify?.locale;
    if (!locale) return;

    function updateAccountLinks() {
      const accountElements = document.querySelectorAll('shopify-account');
      accountElements.forEach(el => {
        const root = el.shadowRoot || el;
        const links = root.querySelectorAll('a');
        links.forEach(link => {
          const href = link.getAttribute('href');
          if (href && (href.includes('/account/orders') || href.includes('/account/addresses'))) {
            try {
              const url = new URL(link.href, window.location.origin);
              if (!url.searchParams.has('locale')) {
                url.searchParams.set('locale', locale);
                link.setAttribute('href', 'https://account.usay-tech.com' + url.pathname.replace('/account', '') + url.search);
              }
            } catch (e) {}
          }
        });
      });
    }

    function initObserver() {
      updateAccountLinks();
      const accountElements = document.querySelectorAll('shopify-account');
      accountElements.forEach(el => {
        if (el.dataset.localeObserverAttached) return;
        el.dataset.localeObserverAttached = 'true';
        
        const root = el.shadowRoot || el;
        const observer = new MutationObserver(updateAccountLinks);
        observer.observe(root, { childList: true, subtree: true });
        
        el.addEventListener('click', updateAccountLinks, { passive: true });
        el.addEventListener('pointerenter', updateAccountLinks, { passive: true });
      });
    }

    if (customElements.get('shopify-account')) {
      initObserver();
    } else {
      customElements.whenDefined('shopify-account').then(initObserver);
    }
  })();
}